import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {BlogService} from '../../../shared/services/blog.service';
import {Location} from '@angular/common';

@Component({
    selector: 'app-add-blog-info',
    templateUrl: './add-blog-info.component.html',
    styleUrls: ['./add-blog-info.component.scss']
})
export class AddBlogInfoComponent implements OnInit {
    public blogId: any;
    public data: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    blogtId: any;
    submitting: any = false;
    submitted: any = false;
    contentData: any;

    constructor(private sanitizer: DomSanitizer,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private blogService: BlogService,
                private _location: Location) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.blogId = this.activatedRoute.snapshot.params['id'];
        this.refresh();
    }

    refresh() {
        this.blogService.detail(this.blogId).subscribe(data => {
            if (data) {
                this.data = data;
                if (this.data && this.data['content']) {
                    this.contentData = this.data['content'];
                }
            } else {
                this.router.navigateByUrl('blogs');
            }
        }, error => {
            this.router.navigateByUrl('blogs');
        });
    }

    submit() {
        const params = {
            'content': this.contentData ? this.contentData : ''
        };
        this.blogService.updateContent(this.blogId, params).subscribe(data => {
            if (data) {
                this.submitting = false;
                this.submitted = false;
            }
          this._location.back();
        }, error => {
            this.submitting = false;
            this.submitted = false;
        });
    }

}
